// extracted by mini-css-extract-plugin
export default {"badge":"CartCountBadge_badge__2DUzY"};